module.exports = __webpack_public_path__ + "static/img/frozen-phase-2.2b98f98.png";